import { Drawer,theme as antdTheme } from 'antd';
import MenuContent from './MenuContent';
import { useTheme } from 'context/ThemeProvider/ThemeProvider';

export const MobileNav = () => {
  const { openMobileNav, setOpenMobileNav } = useTheme();
  const {
    token: { colorBgElevated },
  } = antdTheme.useToken();
  const onClose = () => setOpenMobileNav(false);
  return (
    <Drawer
      placement="left"
      onClose={onClose}
      title="Koras"
      open={openMobileNav}
      styles={{
        body: { padding: 5 },
      }}
    >
      <MenuContent backgroundColor={colorBgElevated} />
    </Drawer>
  );
};

export default MobileNav;
